import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 14 10 2 3 14h18Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 2v16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Sailboat";
const Sailboat = memo(themed(Icon));
export {
  Sailboat
};
//# sourceMappingURL=sailboat.js.map
